import { TableHeaderType } from '../../../common';
import { postionsConstants } from '../../constants/position';
import { reportConstants } from '../../constants/reports';

const playersListMap: TableHeaderType[] = [
	{
		label: reportConstants.REPORT_PLAYER_ID,
		key: reportConstants.COLUMN_PLAYER_ID,
	},
	{
		label: reportConstants.REPORT_EXT_PLAYER_ID,
		key: reportConstants.COLUMN_EXT_PLAYER_ID,
	},
	{
		label: reportConstants.REPORT_VIP_LEVEL,
		key: reportConstants.COLUMN_VIP_LEVEL,
	},
	{
		label: reportConstants.REPORT_PARTNER_SKIN,
		key: reportConstants.COLUMN_PARTNER_SKIN,
	},
	{
		label: reportConstants.REPORT_USERNAME,
		key: reportConstants.COLUMN_USERNAME,
	},
	{ label: reportConstants.REPORT_EMAIL, key: reportConstants.COLUMN_EMAIL },
	{
		label: reportConstants.REPORT_NIKNAME,
		key: reportConstants.COLUMN_NIKNAME,
	},
	{
		label: reportConstants.REPORT_FIRST_NAME,
		key: reportConstants.COLUMN_FIRST_NAME,
	},
	{
		label: reportConstants.REPORT_LAST_NAME,
		key: reportConstants.COLUMN_LAST_NAME,
	},
	{
		label: reportConstants.REPORT_COUNTRY,
		key: reportConstants.COLUMN_COUNTRY,
	},
	{
		label: reportConstants.REPORT_CURRENCY,
		key: reportConstants.COLUMN_CURRENCY,
	},
	{
		label: reportConstants.REPORT_LIFETIME_BET,
		key: reportConstants.COLUMN_LIFETIME_BET,
		position: postionsConstants.RIGHT,
	},
	{
		label: reportConstants.REPORT_LIFETIME_WIN,
		key: reportConstants.COLUMN_LIFETIME_WIN,
		position: postionsConstants.RIGHT,
	},
	{
		label: reportConstants.REPORT_LIFETIME_GGR,
		key: reportConstants.COLUMN_LIFETIME_GGR,
		position: postionsConstants.RIGHT,
	},
	{
		label: reportConstants.REPORT_FIRST_ACTIVITY,
		key: reportConstants.COLUMN_FIRST_ACTIVITY,
	},
	{
		label: reportConstants.REPORT_LAST_ACTIVITY,
		key: reportConstants.COLUMN_LAST_ACTIVITY,
	},
	{
		label: reportConstants.REPORT_LAST_KNOWN_IP,
		key: reportConstants.COLUMN_LAST_KNOWN_IP,
	},
];

const columnFormatter = {
	player_id: 'value',
	external_player_id: 'value',
	vip_level_name: 'value',
	partner: 'value',
	user_name: 'value',
	email: 'value',
	poker_user_name: 'value',
	first_name: 'value',
	last_name: 'value',
	currency: 'value',
	first_activity: 'value',
	last_activity: 'value',
	last_known_ip: 'value',
	bet: 'cents',
	win: 'cents',
	ggr: 'cents',
};

export { playersListMap, columnFormatter };
